module.exports = __webpack_public_path__ + "img/logo2.fb9a93e4.png";